import { render, staticRenderFns } from "./BookPreview.vue?vue&type=template&id=2577c6ea&scoped=true&"
import script from "./BookPreview.vue?vue&type=script&lang=js&"
export * from "./BookPreview.vue?vue&type=script&lang=js&"
import style0 from "./BookPreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BookPreview.vue?vue&type=style&index=1&id=2577c6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2577c6ea",
  null
  
)

export default component.exports